import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
export const Blogs = () => {
  const blogs = [
    {
      category: "TRADING TIPS",
      image: "https://img.freepik.com/free-vector/hand-drawn-cost-living-illustration_52683-142631.jpg?uid=R180299756&ga=GA1.1.815902557.1738949051&semt=ais_hybrid&w=740",
      title: "Top 5 Strategies for Successful Online Trading",
      description: "Learn key trading strategies that can boost your profits and minimize risk.",
      time: "5 min ago",
      comments: 12,
    },
    {
      category: "CRYPTO NEWS",
      image: "https://img.freepik.com/free-vector/cryptocurrency-news-broadcast-illustration_1308-180189.jpg?uid=R180299756&ga=GA1.1.815902557.1738949051&semt=ais_hybrid&w=740",
      title: "Bitcoin vs. Altcoins: Where Should You Invest?",
      description: "Understand the difference between BTC and Altcoins before you put in money.",
      time: "15 min ago",
      comments: 8,
    },
    {
      category: "MARKET INSIGHTS",
      image: "https://img.freepik.com/free-photo/examining-business-documents_1098-18049.jpg?uid=R180299756&ga=GA1.1.815902557.1738949051&semt=ais_hybrid&w=740",
      title: "Will Gold Prices Keep Rising in 2025?",
      description: "Analyzing trends and expert predictions about gold price movements this year.",
      time: "30 min ago",
      comments: 5,
    },
    {
      category: "SECURITY",
      image: "https://img.freepik.com/premium-photo/creative-glowing-blue-shield-hologram-blurry-city-background-secure-safety-database-web-protection-concept-double-exposure_670147-13662.jpg?uid=R180299756&ga=GA1.1.815902557.1738949051&semt=ais_hybrid&w=740",
      title: "How Gold Fox Market Keeps Your Funds Safe",
      description: "A behind-the-scenes look at the security infrastructure of our trading platform.",
      time: "1 hour ago",
      comments: 9,
    },
  ];

  return (
    <>
      <div className="max-w-7xl mx-auto px-5 lg:px-0 py-8">
        <div className="text-center mb-10">
          <span className="text-sm text-gray-600 uppercase tracking-wide">
            BLOG
          </span>
          <h2 className="text-3xl text-gray-800 font-semibold mt-1">
            Our Latest <span className="text-red-500">Blogs</span>
          </h2>
        </div>
        <Swiper
          spaceBetween={20}
          slidesPerView={1}
          loop={true}
          grabCursor={true}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          breakpoints={{
            550: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 4 },
          }}
          modules={[Autoplay, Navigation]}
          className="w-full swiper"
        >
          {blogs.map((blog, index) => (
            <SwiperSlide
              key={index}
              className="bg-white rounded-lg overflow-hidden shadow-sm border border-gray-300"
            >
              <div className="relative">
                <img
                  src={blog.image}
                  alt={blog.title}
                  className="w-full h-48 object-cover"
                />
                <div className="absolute top-4 right-4">
                  <span className="bg-gradient-to-r from-[#263283] to-[#ed2924] text-white text-xs font-medium px-3 py-2 rounded-full uppercase">
                    {blog.category}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0">
                  <span className="bg-red-100 text-red-500 text-xs font-medium px-3 py-1 m-2 inline-block rounded uppercase">
                    {blog.category}
                  </span>
                </div>
              </div>

              <div className="p-4">
                <h3 className="font-semibold text-gray-800 text-base mb-1">
                  {blog.title}
                </h3>
                <p className="text-gray-600 text-sm mb-4">{blog.description}</p>

                <div className="flex text-gray-500 text-xs justify-between items-center">
                  <div className="flex items-center mr-4">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4 mr-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    <span>{blog.time}</span>
                  </div>
                  <div className="flex items-center ">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4 mr-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                      />
                    </svg>
                    <span>{blog.comments} comments</span>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </>
  );
};
